module.exports = __webpack_public_path__ + "static/img/bg2.28ce4214.jpg";